const NUMERIC_SORT_FIELDS = new Set([
  "current_points",
  "current_kickbacks",
]);

const dates = {
  parseDate: (date) => {
    if (!date) return;
    return new Date(date).toLocaleDateString("ro-RO");
  },
  formatDateYMD: (value) => {
    if (!value) return "";
    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) return "";
    const y = dateObj.getFullYear();
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const d = String(dateObj.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  },
  parseSortNumericValue: (value) => {
    if (value === null || value === undefined || value === "") {
      return NaN;
    }
    if (typeof value === "number") {
      return Number.isFinite(value) ? value : NaN;
    }
    if (typeof value !== "string") {
      return NaN;
    }

    let cleaned = value.trim().replace(/\u00A0/g, " ");
    cleaned = cleaned.replace(/[^\d.,\s-]/g, "").trim();

    if (!cleaned || cleaned === "-") {
      return NaN;
    }

    cleaned = cleaned.replace(/\s/g, "");

    const hasComma = cleaned.includes(",");
    const hasDot = cleaned.includes(".");

    if (hasComma && hasDot) {
      const lastComma = cleaned.lastIndexOf(",");
      const lastDot = cleaned.lastIndexOf(".");
      if (lastComma > lastDot) {
        cleaned = cleaned.replace(/\./g, "").replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (hasComma) {
      const parts = cleaned.split(",");
      if (parts.length === 2 && parts[1].length <= 2) {
        cleaned = cleaned.replace(",", ".");
      } else {
        cleaned = cleaned.replace(/,/g, "");
      }
    } else if (hasDot) {
      const parts = cleaned.split(".");
      if (parts.length > 2 || (parts.length === 2 && parts[1].length === 3)) {
        cleaned = cleaned.replace(/\./g, "");
      }
    }

    const num = parseFloat(cleaned);
    return Number.isFinite(num) ? num : NaN;
  },
  compareSortValues: (key, order = "asc") => {
    return function innerSort(a, b) {
      if (key === "last_login" || key === "solved_at") {
        const varA = a[key];
        const varB = b[key];

        if (order === "desc") {
          return new Date(varA) - new Date(varB);
        }
        return new Date(varB) - new Date(varA);
      }

      const shouldSortNumerically =
        NUMERIC_SORT_FIELDS.has(key) ||
        (!Number.isNaN(dates.parseSortNumericValue(a[key])) &&
          !Number.isNaN(dates.parseSortNumericValue(b[key])));

      if (shouldSortNumerically) {
        const numA = dates.parseSortNumericValue(a[key]);
        const numB = dates.parseSortNumericValue(b[key]);
        const aIsNum = !Number.isNaN(numA);
        const bIsNum = !Number.isNaN(numB);

        if (aIsNum && bIsNum) {
          const comparison = numA - numB;
          return order === "desc" ? comparison * -1 : comparison;
        }
        if (aIsNum && !bIsNum) {
          return order === "desc" ? 1 : -1;
        }
        if (!aIsNum && bIsNum) {
          return order === "desc" ? -1 : 1;
        }
      }

      const varA =
        a[key] !== null && typeof a[key] === "string"
          ? a[key].toUpperCase()
          : typeof a[key] === "number"
          ? a[key]
          : "";

      const varB =
        b[key] !== null && typeof b[key] === "string"
          ? b[key].toUpperCase()
          : typeof b[key] === "number"
          ? b[key]
          : "";

      if (typeof varA === "number" && typeof varB === "number") {
        const comparison = varA - varB;
        return order === "desc" ? comparison * -1 : comparison;
      }

      const comparison = String(varA).localeCompare(String(varB));
      return order === "desc" ? comparison * -1 : comparison;
    };
  },
};

export default dates;
